module.exports = __webpack_public_path__ + "static/media/cdb30.e011d508.png";